import React from 'react';
import { Box, keyframes } from '@mui/material';
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

function ScrollDownArrow() {

    const rotateSkill = keyframes`
        0% { top: -5px; }
        100% { top: 5px; }
    `;

    const customSx = {
        position: 'relative',
        textAlign: 'center',
        marginTop: '32px',
        background: '#000',
        animation: `${rotateSkill} 0.8s linear infinite alternate`,
        width: 'fit-content',
        height: 'fit-content',
        borderRadius: '50%',
        padding: '4px',
        margin: '32px auto',
        display: { xs: 'flex', sm: 'none'}
    }

    return <Box sx={customSx}>
        <ArrowDownwardIcon style={{ fontSize: '40px', color: '#fff' }} />
    </Box>;
}

export default ScrollDownArrow;